// src/Montaan/Repo/index.tsx

export { default } from './Repo';
